import _ from 'lodash';
import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { DialogService } from 'app/dialog/services/dialog.service';
import { Observable } from 'rxjs';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { showVirtualEventAuctionMulti } from 'app/virtual-event/features/data/data.actions';
import { SelectionModel } from '@angular/cdk/collections';
import { filter, first } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-show-live-auction-multi',
  templateUrl: './show-live-auction-multi.component.html',
  styleUrls: ['./show-live-auction-multi.component.scss']
})
export class ShowLiveAuctionMultiComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  public form: UntypedFormGroup = null;

  public displayedColumns: string[] = ['select', 'bidder', 'amount'];
  public dataSource = null;

  public selection: SelectionModel<any> = null;

  public buttonDisabled = false;

  itemAmount:number = null

  constructor(
    private store: Store<any>,
    private dialogService: DialogService,
    private formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      'amount': new UntypedFormControl('', [
        Validators.required,
        Validators.min(1)
      ])
    });

    this.form.get('amount').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value) => {
      this.selection.clear();
      this.cdr.markForCheck();
    });

    const initialSelection = [];
    const allowMultiSelect = false;
    this.selection = new SelectionModel<any>(allowMultiSelect, initialSelection);

    this.selection.changed.pipe(
      filter(() => {
        return this.selection.selected.length > 0;
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      const amount = this.form.get('amount');
      if(_.isNull(amount.value)) {
        return false;
      }

      amount.setValue(null);
      amount.clearValidators();
      amount.updateValueAndValidity();
      
      this.cdr.markForCheck();
    });

    this.selection.changed.pipe(
      filter(() => {
        return this.selection.selected.length < 1;
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      const amount = this.form.get('amount');
      amount.clearValidators();
      amount.setValidators([
        Validators.required,
        Validators.min(1)
      ]);
      amount.updateValueAndValidity();
      this.cdr.markForCheck();
    });

    this.dialog$.pipe(first(),takeUntilDestroyed(this.destroyRef)).subscribe(({ initialState: { option }} ) => {
      const list = _.get(option, 'currentBids', []) || [];
      this.dataSource = _.slice(list, 0, 3);
    });
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.forEach(row => this.selection.select(row));
  }

  close(dialog, value) {
    const { selection } = this;
    this.dialogService.closeDialogSubject.next(value);

    const { initialState: { eventId, campaignId, option: { id: optionId }, callback } } = dialog;

    if(value) {
      let amount = (selection.selected.length > 0) ?
        this.itemAmount:
        this.form.get('amount').value;  
      this.store.dispatch({
        type: showVirtualEventAuctionMulti.type,
        payload: { eventId, campaignId, optionId, amount }
      });
      callback(value);
    }
  }
  show(event:any, amount = null){
    event.stopPropagation()
    if(amount){
      this.itemAmount = amount
    }
 }

 
}
